/**
 * Google OAuth2 callback page — opened in a popup window.
 *
 * Google redirects here with ?code=... after the user grants consent.
 * This page sends the code back to the parent window via postMessage,
 * then closes itself.
 */

import { useEffect } from 'react'

export function GoogleOAuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const error = params.get('error')

    if (window.opener) {
      window.opener.postMessage(
        { type: 'google-oauth-callback', code, error },
        window.location.origin,
      )
    }

    // Close the popup after a short delay
    setTimeout(() => window.close(), 500)
  }, [])

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center space-y-2">
        <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full mx-auto" />
        <p className="text-sm text-muted-foreground">Completing authorization...</p>
      </div>
    </div>
  )
}
